import { LS_KEY_EMAIL_LINK_LOGIN_KEY } from "@/config/localStorageKeys";
import { useMobileDetect } from "@/hooks/useMobileDetect";
import { caremeTheme } from "@/libs/theme";
import {
	Box,
	Button,
	Divider,
	Link,
	List,
	ListItem,
	ListItemButton,
	SwipeableDrawer,
	Typography,
} from "@mui/material";
import { Container } from "@mui/system";
import Image from "next/image";
import NextLink from "next/link";
import { useEffect, useState } from "react";

export function EmailSent() {
	const mobileDetect = useMobileDetect();

	const [email, setEmail] = useState("");
	const [isOpenDrawer, setIsOpenDrawer] = useState(false);

	const openDrawer = () => {
		setIsOpenDrawer(true);
	};

	const closeDrawer = () => {
		setIsOpenDrawer(false);
	};

	useEffect(() => {
		setEmail(window.localStorage.getItem(LS_KEY_EMAIL_LINK_LOGIN_KEY) || "");
	}, []);

	return (
		<Container component="main" maxWidth="xs">
			<Box
				mt={6}
				mx={6}
				display="flex"
				flexDirection="column"
				alignItems="center"
			>
				<Image
					src="/email-sent-header.png"
					width={88}
					height={88}
					alt="メールを送信しましたと言う画像"
				/>
				<Typography
					mt={4}
					component="h1"
					variant="subtitle1"
					textAlign="center"
				>
					メールを確認してください
				</Typography>
				<Typography mt={4} variant="body1" textAlign="center">
					{`${email}に送信したメール内のリンクをタップするとログインできます`}
				</Typography>

				<Button
					fullWidth
					variant="contained"
					sx={{ mt: 4 }}
					onClick={openDrawer}
				>
					メールアプリを開く
				</Button>

				<SwipeableDrawer
					anchor="bottom"
					open={isOpenDrawer}
					onOpen={openDrawer}
					onClose={closeDrawer}
				>
					<List>
						{mobileDetect.isAndroid() ? (
							<>
								<ListItem sx={{ typography: "body1" }}>
									<ListItemButton href="android-app://com.google.android.gm">
										メール
									</ListItemButton>
								</ListItem>
								<Divider />
								<ListItem sx={{ typography: "body1" }}>
									<ListItemButton href="android-app://jp.co.yahoo.android.ymail">
										Yahoo!メール
									</ListItemButton>
								</ListItem>
								<Divider />
								<ListItem sx={{ typography: "body1" }}>
									<ListItemButton href="android-app://com.microsoft.office.outlook">
										Microsoft Outlook
									</ListItemButton>
								</ListItem>
								<Divider />
								<ListItem sx={{ typography: "body1" }}>
									<ListItemButton onClick={closeDrawer}>閉じる</ListItemButton>
								</ListItem>
							</>
						) : (
							<>
								<ListItem sx={{ typography: "body1" }}>
									<ListItemButton href="message:">メール</ListItemButton>
								</ListItem>
								<Divider />
								<ListItem sx={{ typography: "body1" }}>
									<ListItemButton href="googlegmail://">Gmail</ListItemButton>
								</ListItem>
								<Divider />
								<ListItem sx={{ typography: "body1" }}>
									<ListItemButton href="yjmail://">Yahoo!メール</ListItemButton>
								</ListItem>
								<Divider />
								<ListItem sx={{ typography: "body1" }}>
									<ListItemButton href="ms-outlook://">
										Microsoft Outlook
									</ListItemButton>
								</ListItem>
								<Divider />
								<ListItem sx={{ typography: "body1" }}>
									<ListItemButton onClick={closeDrawer}>閉じる</ListItemButton>
								</ListItem>
							</>
						)}
					</List>
				</SwipeableDrawer>

				<Typography mt={3} variant="body2" textAlign="center">
					<Link
						component={NextLink}
						href="/signin-with-password"
						underline="none"
						typography="subtitle2"
						color={caremeTheme.palette.primary.main}
					>
						パスワードでログインする
					</Link>
				</Typography>
			</Box>
		</Container>
	);
}
